<template>
  <div>
    <Header />

    <div class="section section-about section-pad bg-light">
      <div class="container">
        <div class="content row">
          <div class="wide center">
            <h1 class="heading-section">CAREERS</h1>
            <h4 class="lead" style="text-align: justify;">
              We are a company of opportunity for those who work hard, are
              determined, have grit and demonstrate true passion for food,
              retail and service to people. In principle and practice, Sundry
              Foods is powered by People. We employ only the very best and
              invest in the learning, career growth and development of our
              people. We are committed to giving our people opportunities they
              do not get anywhere else: A Career path, Training, compensation
              and a chance to do work that creates live impact in people.
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-content section-pad">
      <div class="container">
        <div class="content row">
          <h1 class="heading-section text-center">SUNDRY FOODS</h1>
          <div class="row row-vm">
            <div class="col-sm-6 res-m-bttm">
              <div>
                <p>
                  Join Sundry Foods Limited if you want to be part of a company
                  that leads the delivery of a world-class food service to its
                  customers. We’re looking for people to join our team who are
                  as excited as we are to blaze new trails in Food service and
                  hospitality.
                </p>

                <p>
                  We offer our people the chance to build a career in the Food
                  Service and Hospitality Industry, the opportunity to challenge
                  yourself and learn new skills, the opportunity to work with
                  people, through people and for people. That is the kind of
                  work you can expect at Sundry Foods. Does this align with your
                  career aspirations? Come join us.
                </p>

                <p>
                  Working at Sundry Foods means you get to show what you are
                  made of in a fast pace performance-driven environment. We
                  value passion for food and people, drive for results and
                  continuous improvement, great leadership, intrapreneurship, a
                  positive attitude and intellect. Do you share our values?
                </p>
              </div>
            </div>
            <div class="col-sm-5 col-sm-offset-1">
              <img src="../assets/img/sundry_food.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="section section-content section-pad">
      <div class="container">
        <div class="content row">
          <div class="row row-vm">
            <div class="col-sm-5">
              <h2>Sundry Markets</h2>
              <img src="../assets/img/sundry_market.jpg" alt="">
            </div>
            <div class="col-sm-7">
              <div>
                <p>Join Sundry Markets Limited if you want to be part of a company that leads the delivery of a
                  world-class
                  grocery retail service to its customers. We offer our people the chance to build a career in
                  Nigeria’s booming
                  Modern Retail Industry, the opportunity to challenge yourself and learn new skills, the opportunity
                  to work
                  with people, through people and for people. That is the kind of work you can expect at Sundry
                  Markets. Does
                  this align with your career aspirations? Come join us.</p>

                <p>Working at Sundry Markets means you get to show what you are made of in a fast pace
                  performance-driven
                  environment.. We value drive for results, service, great leadership, continuous improvement,
                  intrapreneurship,
                  a positive attitude and initiative. Do you share our values?</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="section section-content section-pad" id="openings">
      <div class="container">
        <div class="content row">
          <div class="center">
            <h2 class="heading-section">BROWSE OPENINGS</h2>
          </div>
          <div class="filters">
            <!-- <div class="col-lg-4 col-md-4 col-sm-12">
              <select
                class="form-control no-radius sundry-orange-border-1"
                v-model="search.selected_company"
                v-on:change="filterCompany"
              >
                <option
                  v-for="company in companies"
                  v-bind:value="company.id"
                >{{company.company_name}}</option>
              </select>
            </div> -->
            <div class="col-lg-8 col-md-8 col-sm-12">
              <div class="check">
                <input
                  type="text"
                  name=""
                  class="form-control no-radius sundry-orange-border-1"
                  placeholder="Search openings by role, location or description..."
                  v-model="search.query"
                />
                <button @click="filterJobs">Search</button>
              </div>
              <span class="warning" v-show="search.selected_company_error"
                >Please select company</span
              >
            </div>
          </div>
        </div>
        <div class="row job-entries">
          <div
            v-for="opening in openings"
            class="col-lg-12 col-md-12 col-sm-12 single-entry"
          >
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a
                      data-toggle="collapse"
                      v-bind:href="'#collapsedata' + opening.id"
                    >
                      {{ opening.role_name }}

                      <div class="opening-meta">
                        <span class="company_name">
                          <i class="fa fa-university"></i>
                          {{ opening.company_name }}
                        </span>
                        <br />
                        <i class="fa fa-map-marker"></i>
                        <span v-for="(location, index) in opening.locations">
                          <span v-if="index !== opening.locations.length - 1">
                            {{ location.city }},
                          </span>
                          <span v-else>
                            {{ location.city }}
                          </span>
                        </span>
                      </div>
                    </a>
                  </h4>
                </div>
                <div
                  v-bind:id="'collapsedata' + opening.id"
                  class="panel-collapse collapse"
                >
                  <div
                    class="panel-body"
                    v-html="jobdescription(opening.jobdescription)"
                  ></div>
                  <div class="share-icons">
                    <a
                      title="Share to Facebook"
                      class="btn btn-facebook"
                      target="_blank"
                      v-bind:href="
                        'https://www.facebook.com/sharer/sharer.php?u=https://careers.sundryfood.com/application/' +
                          opening.id
                      "
                    >
                      <i class="fa fa-facebook"></i>
                    </a>
                    <a
                      title="Share to LinkedIn"
                      class="btn btn-linkedin"
                      target="_blank"
                      v-bind:href="
                        'https://www.linkedin.com/sharing/share-offsite/?url=https://careers.sundryfood.com/application/' +
                          opening.id
                      "
                    >
                      <i class="fa fa-linkedin"></i>
                    </a>
                  </div>
                  <div class="panel-footer center">
                    <a
                      v-bind:href="'application/' + opening.id"
                      class="btn btn-sm btn-primary"
                      >Apply Now</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<style>
.panel-group {
  border: 0px !important;
  border-bottom: 1px solid #fea323 !important;
}

.warning {
  font-size: 14px;
  color: #000;
}

.company_name {
  text-transform: capitalize;
}

.opening-meta,
.opening-meta span {
  font-size: 14px !important;
  color: #564f4f !important;
  line-height: 1.6;
  margin-top: 2px;
}

.btn-dribbble i,
.btn-dropbox i,
.btn-facebook i,
.btn-flickr i,
.btn-github i,
.btn-google-plus i,
.btn-instagram i,
.btn-linkedin i,
.btn-pinterest i,
.btn-skype i,
.btn-tumblr i,
.btn-twitter i,
.btn-youtube i {
  margin: 0 !important;
  padding: 0px !important;
}

.share-icons {
  margin-bottom: 20px;
  padding: 15px;
}

.share-icons .btn {
  margin-bottom: 20px;
  margin-right: 10px;
}

.check {
  display: flex;
  align-items: center;
  gap: 3px;
}
.check button {
  height: 44.8px !important;
  border-radius: 5px !important;
  background: #ffa01b;
  border: 2px solid #ffa01b !important;
  outline: 0 !important;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
  padding: 10px;
  text-transform: capitalize;
}

.btn-facebook {
  background-color: #3c5a99 !important;
  border-color: #3c5a99 !important;
  border-radius: 2px !important;
  color: #fff !important;
  cursor: pointer !important;
}

.btn-linkedin {
  background-color: #007bb6 !important;
}

.form-control {
  padding: 4px 7px;
  font-size: 11px;
}

.res-m-bttm p {
  font-size: 15px;
  color: #353a42;
  font-weight: 300;
}
</style>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Home",
  data() {
    return {
      openings: [],
      companies: [
        {
          id: "1",
          company_name: "Sundry Foods",
        },
      ],
      search: {
        selected_company: "1",
        selected_company_error: false,
        query: "",
      },
    };
  },
  components: {
    Header,
    Footer,
  },
  methods: {
    getAllOpenings() {
      var get_openings_request = {
        what: "openings",
      };

      this.$socket
        .makeGetRequest(get_openings_request)
        .then((response) => {
          if (response.type == "openings") {
            response.data.forEach((i) => {
              i.company_name = "Sundry Foods";
            });
            this.openings = response.data;
            this.$swal.close();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    filterJobs(e) {
      const input = this.search.query;

      if (input.length > 0) {
        if (
          this.search.selected_company == "" ||
          this.search.selected_company == "0"
        ) {
          this.search.selected_company_error = true;
        } else {
          this.search.selected_company_error = false;

          this.getJobsByParams(this.search.selected_company, this.search.query);
        }
      } else {
        this.getAllOpenings();
      }
    },

    getJobsByParams(company_id, query) {
      var search_jobs = {
        what: "SearchJobs",
        params: {
          company_id: company_id,
          q: query,
        },
        showLoader: false,
      };

      this.$socket
        .makeGetRequest(search_jobs)
        .then((response) => {
          //console.log(response)
          if (response.type == "SearchJobs") {
            this.openings = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanies() {
      var companies = {
        what: "Companies",
      };

      this.$socket
        .makeGetRequest(companies)
        .then((response) => {
          if (response.type == "Companies") {
            // console.log(response.data)
            for (var i = 0; i < response.data.length; i++) {
              this.companies.push(response.data[i]);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    filterCompany(e) {
      //console.log(e)
      var company_id = e.target.value;
      if (company_id !== "0") {
        this.getJobsByParams(company_id, "");
      } else {
        this.getAllOpenings();
      }
    },

    jobdescription: function(jd) {
      return jd.length > 250 ? jd.substring(0, 250) + "..." : jd;
    },
  },
  mounted() {
    var loading_html =
      '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>';

    this.$swal.fire({
      title: "<h5></h5>",
      html: loading_html,
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: false,
    });

    this.getAllOpenings();
    this.getCompanies();
  },
};
</script>
